module.exports = __webpack_public_path__ + "static/NotoSerif-Italic-deb22570d2ad863f3dd876e480ff12c7.woff";